export default {
  FONT_FAMILIES: {
    FIRST: '"IBM Plex Sans Thai", sans-serif',
    SECOND: '"IBM Plex Sans Thai", sans-serif',
  },
  FONT_SIZES_PX: {
    MN: '10px',
    TN: '12px',
    XXS: '13px',

    //now using
    XS: '14px',
    SM: '16px',
    MD: '17px',
    LG: '20px',

    XL: '24px',

    //now using
    XXL: '26px',
    BG: '30px',

    HG: '48px',
    MS: '64px',
  },
  FONT_SIZES_VW: {
    MN: '10px',
    TN: '12px',
    XXS: '13px',

    //now using
    XS: '14px',
    SM: '16px',
    MD: '17px', //0.89vw
    LG: '20px',

    XL: '24px',

    //now using
    XXL: '26px',
    BG: '30px',

    HG: '48px',
    MS: '64px',
  },
  FONT_WEIGHT: {
    FIRST_THIN: 100,
    FIRST_EXTRA_LIGHT: 200,
    FIRST_LIGHT: 300,
    FIRST_NORMAL: 'normal',
    FIRST_MEDIUM: 500,
    FIRST_SEMI_BOLD: 600,
    FIRST_BOLD: 'bold',
    FIRST_EXTRA_BOLD: 800,
    FIRST_BLACK: 900,

    SECOND_REGULAR: 'normal',
  },
}
